const map = {
	"./2010/Venue/Index.vue": 42051,
	"./2011/Venue/Index.vue": 48683,
	"./2012/Venue/Index.vue": 6286,
	"./2013/Venue/Index.vue": 63499,
	"./2014/Venue/Index.vue": 7942,
	"./2015/Venue/Index.vue": 48652,
	"./2016/Venue/Index.vue": 97485,
	"./2017/Venue/Index.vue": 49370,
	"./2018/Venue/Index.vue": 4921,
	"./2019/Venue/Index.vue": 10987,
	"./2023/Venue/Index.vue": 45860,
	"./2024/Venue/Index.vue": 54966,
	"./2025/Venue/Index.vue": 9462,
	"./2026/Venue/Index.vue": 53649
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36608;